import Interceptor from "./Interceptor";

/**
 * Migration Service
 * Handles site migrations between environments using the dedicated migration API
 */

/**
 * Migrate site between environments (SANDBOX → STAGING → PRODUCTION)
 * @param {string} siteId - Site ID
 * @param {object} payload - Migration configuration
 * @param {string} payload.targetEnvironment - Target environment (STAGING or PRODUCTION)
 * @param {boolean} payload.createBackup - Create backup before migration (default: true)
 * @param {string} payload.customDomain - Custom domain for PRODUCTION (optional)
 * @param {boolean} payload.rollbackOnFailure - Auto-rollback on failure (default: true)
 */
export const migrateSite = async (siteId, payload) => {
  try {
    const response = await Interceptor.post(
      `/migrations/sites/${siteId}/migrate`,
      payload,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get list of deployments with pagination
 * @param {object} params - Query parameters
 * @param {string} params.siteId - Filter by site ID (optional)
 * @param {number} params.page - Page number (default: 1)
 * @param {number} params.limit - Items per page (default: 10)
 */
export const getDeployments = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const response = await Interceptor.get(
      `/migrations/deployments?${queryParams}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get deployment details by ID
 * @param {string} deploymentId - Deployment ID
 */
export const getDeploymentById = async (deploymentId) => {
  try {
    const response = await Interceptor.get(
      `/migrations/deployments/${deploymentId}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Rollback a deployment
 * @param {string} deploymentId - Deployment ID to rollback
 */
export const rollbackDeployment = async (deploymentId) => {
  try {
    const response = await Interceptor.post(
      `/migrations/deployments/${deploymentId}/rollback`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

const MigrationService = {
  migrateSite,
  getDeployments,
  getDeploymentById,
  rollbackDeployment,
};

export default MigrationService;
